export namespace UserNamespace {
    export interface UserApiInterface {
        id: number;
        email: string;
        permissions: string[];
        username: string;
    }

    /**
     * Разрешения пользователя
     */
    export enum Permission {
        login = 'frontend-login',
        /**
         * Может создавать собственное оборудование
         */
        createOwnEquipment = 'apparatus-card-create-postmoderated',

        /**
         * Удаление карточек оборудования
         */
        equipmentCardDelete = 'apparatus-card-delete',
        equipmentCardUpdate = 'apparatus-card-update',

        /**
         * Генерация и загрузка различных документов оборудования
         */
        equipmentGenerateCardsArchive = 'apparatus-card-generate-cards-archive',
        equipmentGenerateCardsList = 'apparatus-card-generate-list',
        equipmentGenerateCalibrationRequestDocument = 'apparatus-card-generate-request-calibration',
        equipmentGenerateCalibrationSchedule = 'apparatus-card-generate-calibration-schedule',
        equipmentDownloadCalibrationRequestDocument = 'apparatus-card-download-request-calibration',

        /**
         * Добавление, удаление, изменение поверок оборудования
         */
        equipmentCardCalibrationAdd = 'apparatus-card-calibration-add',
        equipmentCardCalibrationRemove = 'apparatus-card-calibration-delete',
        equipmentCardCalibrationUpdate = 'apparatus-card-calibration-update',

        /**
         * Смена статуса специалиста
         */
        specialistSetStatus = 'specialist-set-status',

        /**
         * Генерация документа списка специалистов
         */
        specialistGenerateList = 'specialist-generate-list',

        /**
         * Просмотр уволенных специалистов
         */
        specialistViewFired = 'specialist-list-dismissed',

        /**
         * Генерация графика аттестации персонала
         */
        specialistGenerateAttestationSchedule = 'specialist-generate-attestation-schedule',

        /**
         * Просмотр списка, создание, редактирование и удаление копии документа структурной единицы (организации/лаборатории/...)
         */
        structureUnitDocumentList = 'structure-unit-doc-list',
        structureUnitDocumentCreate = 'structure-unit-doc-create',
        structureUnitDocumentUpdate = 'structure-unit-doc-update',
        structureUnitDocumentRemove = 'structure-unit-doc-delete',

        /**
         * Права доступа к визарду документов ЛНК
         */
        wizardDocumentsView = 'lab-docs-view',
        wizardDocumentsCreate = 'lab-docs-create',
        wizardDocumentsUpdate = 'lab-docs-update',
        wizardDocumentsDownloadArchive = 'lab-docs-download-batch',
        wizardDocumentsDownloadSingleDocument = 'lab-docs-download-single',
        wizardDocumentsAddNtdDocument = 'lab-docs-ntd-add',

        /**
         * Права доступа к разделу объектов Working Objects
         */
        workingObjectCreate = 'working-object-create',
        workingObjectList = 'working-object-list',
        workingObjectDelete = 'working-object-delete',
        workingObjectUpdate = 'working-object-update',
        workingObjectView = 'working-object-view',
        workingObjectEquipment = 'working-object-apparatus-card',
        workingObjectSpecialists = 'working-object-specialist',
        workingObjectStatusChange = 'working-object-set-status',
        workingObjectTechnicalDeviceCreate = 'working-object-technical-device-create',
        workingObjectTechnicalDeviceUpdate = 'working-object-technical-device-update',
        workingObjectTechnicalDeviceView = 'working-object-technical-device-view',

        /**
         * Права доступа к разделу технических устройств
         */
        technicalDeviceCreate = 'technical-device-create',
        technicalDeviceUpdate = 'technical-device-update',
        technicalDeviceView = 'technical-device-view',
        technicalDeviceDelete = 'technical-device-delete',
        technicalDeviceList = 'technical-device-list',
        technicalDeviceSetStatus = 'technical-device-set-status',

        /**
         * Права доступа к разделу типоразмеров/групп_элементов технического устройства
         */
        technicalDeviceElementGroupCreate = 'technical-device-element-group-create',
        technicalDeviceElementGroupUpdate = 'technical-device-element-group-update',
        technicalDeviceElementGroupView = 'technical-device-element-group-view',
        technicalDeviceElementGroupDelete = 'technical-device-element-group-delete',
        technicalDeviceElementGroupList = 'technical-device-element-group-list',

        /**
         * Права доступа к техническим картам типоразмеров технических устройств
         */
        technicalCardCreate = 'technical-card-create',
        technicalCardUpdate = 'technical-card-update',
        technicalCardView = 'technical-card-view',
        technicalCardDelete = 'technical-card-delete',
        technicalCardList = 'technical-card-list',

        /**
         * Права доступа к разделу элементов технического устройства
         */
        technicalDeviceElementCreate = 'technical-device-elements-create',
        technicalDeviceElementUpdate = 'technical-device-elements-update',
        technicalDeviceElementView = 'technical-device-elements-view',
        technicalDeviceElementDelete = 'technical-device-elements-delete',
        technicalDeviceElementList = 'technical-device-elements-list',

        /**
         * Права доступа к разделу заключений технического устройства
         */
        technicalDeviceConclusionCreate = 'conclusion-create',
        technicalDeviceConclusionUpdate = 'conclusion-update',
        technicalDeviceConclusionView = 'conclusion-view',
        technicalDeviceConclusionDelete = 'conclusion-delete',
        technicalDeviceConclusionList = 'conclusion-list',
        technicalDeviceConclusionGenerateArchive = 'conclusion-generate-conclusions-archive',

        /**
         * Права доступа к разделу заключений технического устройства
         */
        technicalDeviceDocumentationCreate = 'technical-device-document-create',
        technicalDeviceDocumentationUpdate = 'technical-device-document-update',
        technicalDeviceDocumentationView = 'technical-device-document-view',
        technicalDeviceDocumentationDelete = 'technical-device-document-delete',
        technicalDeviceDocumentationList = 'technical-device-document-list',

        /**
         * Доступ к разделам целиком
         */
        accessModuleOrganization = 'organization',  // Настройки организации
        accessModuleDocuments = 'lab-docs',         // Доступ к документам ЛНК

        /**
         * Доступ к управлению пользователями организации
         */
        organizationUser = 'org-user', // Доступ к разделу целиком
        organizationUserBlock = 'org-user-block',
        organizationUserChangeRole = 'org-user-change-role',
        organizationUserCreate = 'org-user-create',
        organizationUserView = 'org-user-view',

        /**
         * Операции над лабораторией
         */
        laboratoryUpdate = 'laboratory-update',
    }
}
